export default __webpack_public_path__ + "90b92c23abe39dfcccb4bf1f4ee08bb8.jpg";